import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  ref: "previewContainer",
  class: "bg-white rounded-xl ma-5 py-4 pl-4 pr-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  style: {"overflow-y":"auto","height":"calc(100vh - 192px)","overflow-x":"hidden"},
  class: "pr-1"
}
const _hoisted_5 = { class: "elevation-0" }
const _hoisted_6 = { class: "border rounded-xl pa-3" }
const _hoisted_7 = { class: "subtitle-1 font-weight-bold w-100" }
const _hoisted_8 = { class: "mr-1 w-25" }
const _hoisted_9 = {
  key: 0,
  class: "ml-1 w-25"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "d-flex flex-row flex-grow-1" }
const _hoisted_14 = { class: "totals text-right justify-end" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "d-flex flex-row flex-grow-1" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "py-3" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "totals text-right" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 2,
  style: {"font-weight":"normal"}
}
const _hoisted_27 = { class: "totals text-right" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  style: {"font-size":"0.95em","font-weight":"normal"}
}
const _hoisted_31 = {
  key: 0,
  class: "bg-white rounded-xl mr-3 py-3 mb-2 ml-0"
}
const _hoisted_32 = {
  key: 0,
  class: "text-red"
}
const _hoisted_33 = { class: "bg-white rounded-xl py-3 mr-3 my-2 ml-0" }
const _hoisted_34 = {
  key: 1,
  class: "default_card ml-0"
}
const _hoisted_35 = {
  key: 2,
  class: "default_card ml-0"
}
const _hoisted_36 = {
  key: 3,
  class: "default_card ml-0"
}
const _hoisted_37 = {
  key: 4,
  class: "default_card ml-0"
}
const _hoisted_38 = {
  key: 5,
  class: "default_card ml-0 my-0"
}
const _hoisted_39 = {
  key: 6,
  class: "default_card ml-0 my-0"
}
const _hoisted_40 = { class: "mt-auto pa-4 d-flex justify-end" }
const _hoisted_41 = { class: "d-flex mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_MailerDialog = _resolveComponent("MailerDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_InvoiceProductsDialog = _resolveComponent("InvoiceProductsDialog")!
  const _component_CreateDeposit = _resolveComponent("CreateDeposit")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_InvoiceMatrix = _resolveComponent("InvoiceMatrix")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_InvoiceHtmlTemplateView = _resolveComponent("InvoiceHtmlTemplateView")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_editCompany = _resolveComponent("editCompany")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_InvoiceThirdCompanyUsersDialog = _resolveComponent("InvoiceThirdCompanyUsersDialog")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_InvoiceConfirmInvoice = _resolveComponent("InvoiceConfirmInvoice")!
  const _component_Pay = _resolveComponent("Pay")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_v_row, {
    ref: "mainContainer",
    "no-gutters": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: !_ctx.isInvoiceMatrix ? 8 : 12
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pb-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "px-0 pt-0 pb-1 d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_back, {
                      size: "small",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_v_text_field_filled, {
                      readonly: "",
                      label: "État",
                      "hide-details": "",
                      "model-value": _ctx.selectedStatus.text,
                      density: "compact"
                    }, null, 8, ["model-value"]), [
                      [_directive_sanitize]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    (
                                (_ctx.isInvoice || _ctx.isCreditNote) &&
                                (_ctx.invoice.status === 'VALIDATED' ||
                                    _ctx.invoice.status === 'BEING_VALIDATED') &&
                                !_ctx.invoice.document
                            )
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          loading: _ctx.isSaving,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setConfirmInvoiceFirstStep())),
                          disabled: _ctx.disabledCreateDocument,
                          class: "ml-2",
                          elevation: "0",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[100] || (_cache[100] = [
                            _createTextVNode(" Créer le document pour la facture ")
                          ])),
                          _: 1
                        }, 8, ["loading", "disabled"]))
                      : (_ctx.isQuote && _ctx.invoice.status === 'VALIDATED')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            onClick: _ctx.acceptInvoice,
                            class: "ml-2",
                            elevation: "0",
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[101] || (_cache[101] = [
                              _createTextVNode(" Accepté par le client ")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_ctx.showValidateButton)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              loading: _ctx.isSaving,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => {
                                _ctx.showPreviewToggle = false;
                                _ctx.verifInvoiceDate();
                            }),
                              disabled: _ctx.disabledValidate,
                              class: "ml-2",
                              elevation: "0",
                              "data-cy": "InvoiceEdition-valider",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _cache[102] || (_cache[102] = _createTextVNode(" Valider ")),
                                (_ctx.isInvoice)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("la facture")
                                    ], 64))
                                  : (_ctx.isInvoiceMatrix)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("les factures multiples")
                                      ], 64))
                                    : (_ctx.isQuote)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createTextVNode("le devis")
                                        ], 64))
                                      : (_ctx.isBillOfDelivery)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createTextVNode("le BL")
                                          ], 64))
                                        : (_ctx.isCreditNote)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                              _createTextVNode("l'avoir")
                                            ], 64))
                                          : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled"]))
                          : _createCommentVNode("", true),
                    (!_ctx.isLocked && _ctx.isInvoiceMatrix)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 3,
                          class: "elevation-0 ml-2",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveInvoice())),
                          loading: _ctx.isSaving,
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[103] || (_cache[103] = [
                            _createTextVNode(" Enregistrer ")
                          ])),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (_ctx.localStepData && _ctx.localStepData.action !== '')
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 4,
                          color: "primary",
                          height: "10",
                          "buffer-value": "0",
                          stream: "",
                          class: "ml-2",
                          "model-value": _ctx.progressValue
                        }, null, 8, ["model-value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "d-flex justify-end align-center pa-0 mt-1"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_TutorialButtonDialog, {
                          key: 0,
                          starterComponents: 'InvoiceEdition'
                        }))
                      : _createCommentVNode("", true),
                    (
                                _ctx.invoice.status === 'DRAFT' &&
                                _ctx.invoice.type !== 'INVOICE_RECURRENT' &&
                                _ctx.invoice.type !== 'INVOICE_MATRIX'
                            )
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 1,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({
                              icon: !_ctx.showPreviewToggle ? '$oss-eye' : '$oss-edit',
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPreviewToggle = !_ctx.showPreviewToggle))
                            }, props), null, 16, ["icon"])
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.showPreviewToggle)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Prévisualiser le document"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_3, "Retourner à l'édition"))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_tooltip, { location: "top" }, {
                      activator: _withCtx(({ props }) => [
                        (_ctx.isQuote || _ctx.isBillOfDelivery)
                          ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({
                              key: 0,
                              icon: "$oss-sync",
                              class: "elevation-0 mx-2",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.convertDocumentDialog = true))
                            }, props, {
                              loading: _ctx.isSaving,
                              disabled: 
                                        _ctx.invoice.status === 'DRAFT' ||
                                        (!!_ctx.invoice.deposits && !!_ctx.invoice.deposits.length)
                                    ,
                              size: "small"
                            }), null, 16, ["loading", "disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _cache[104] || (_cache[104] = _createElementVNode("span", null, "Convertir", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                      activator: _withCtx(({ props }) => [
                        (_ctx.isQuote)
                          ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({
                              key: 0,
                              icon: "$oss-letter",
                              class: "elevation-0 mx-2"
                            }, props, {
                              disabled: 
                                        !_ctx.enableSignature || !_ctx.containsReceivers || !_ctx.invoice.document
                                    ,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.askForSignature()))
                            }), null, 16, ["disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _cache[105] || (_cache[105] = _createElementVNode("span", null, "Signer", -1))
                      ]),
                      _: 1
                    }),
                    (_ctx.enableSendMail)
                      ? (_openBlock(), _createBlock(_component_v_menu, {
                          key: 2,
                          "open-on-hover": "",
                          "offset-y": "",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({
                              icon: "$oss-mail",
                              class: "elevation-0 mx-2"
                            }, props, {
                              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.getDefaultMailer()), ["stop"]))
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            (_ctx.enablePayment || _ctx.enableSignature)
                              ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, {
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getDefaultMailer()))
                                    }, {
                                      default: _withCtx(() => _cache[106] || (_cache[106] = [
                                        _createTextVNode(" Envoyer par mail ")
                                      ])),
                                      _: 1
                                    }),
                                    (_ctx.enablePayment)
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 0,
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPayDialog()))
                                        }, {
                                          default: _withCtx(() => _cache[107] || (_cache[107] = [
                                            _createTextVNode(" Envoyer par mail avec un lien de paiement ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.enableSignature)
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 1,
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getDefaultMailerWithSignature()))
                                        }, {
                                          default: _withCtx(() => _cache[108] || (_cache[108] = [
                                            _createTextVNode(" Envoyer par mail avec un lien pour signature ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isNewInvoice)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 3,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({
                              icon: "$oss-duplicate",
                              class: "elevation-0 mx-2"
                            }, props, {
                              disabled: !!_ctx.invoice.depositOf,
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogConfirmDuplicate = true)),
                              "data-cy": "InvoiceEdition-duplicate"
                            }), null, 16, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _cache[109] || (_cache[109] = _createElementVNode("span", null, "Dupliquer", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                                !_ctx.isNewInvoice &&
                                !_ctx.isRecurrent &&
                                _ctx.localStepData &&
                                _ctx.localStepData.action !== 'download'
                            )
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 4,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({
                              icon: "$oss-download",
                              elevation: "0",
                              class: "mx-2"
                            }, props, {
                              onClick: _ctx.printInvoice,
                              disabled: _ctx.disabledDownload,
                              loading: _ctx.downloadLoading,
                              "data-cy": "InvoiceEdition-download"
                            }), null, 16, ["onClick", "disabled", "loading"])
                          ]),
                          default: _withCtx(() => [
                            _cache[110] || (_cache[110] = _createElementVNode("span", null, "Télécharger", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.localStepData && _ctx.localStepData.action === 'download')
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 5,
                          size: 24,
                          rounded: "",
                          "model-value": _ctx.progressValue
                        }, null, 8, ["model-value"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_menu, { "offset-y": "" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_ctx.allowToCreateACreditNote)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogCreditNote = true)),
                                  "data-cy": "InvoiceEdition-avoir"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[111] || (_cache[111] = [
                                        _createTextVNode("Créer un avoir")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.allowToCreateACreditNote)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancelAndReplaceDialog = true)),
                                  "data-cy": "InvoiceEdition-cancelAndReplaceInvoice"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[112] || (_cache[112] = [
                                        _createTextVNode("Annule et remplace")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.allowToCreateACreditNote)
                              ? (_openBlock(), _createBlock(_component_v_divider, { key: 2 }))
                              : _createCommentVNode("", true),
                            (
                                        (_ctx.isInvoice || _ctx.isInvoiceMatrix || _ctx.isCreditNote) &&
                                        _ctx.invoice.status === 'VALIDATED' &&
                                        _ctx.invoice.document
                                    )
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 3,
                                  onClick: _cache[14] || (_cache[14] = 
                                        () =>
                                            !_ctx.regenerateInvoiceDocumentLoading &&
                                            _ctx.regenerateInvoiceDocument()
                                    )
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        (_ctx.regenerateInvoiceDocumentLoading)
                                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                              key: 0,
                                              indeterminate: "",
                                              size: "16",
                                              width: "2"
                                            }))
                                          : _createCommentVNode("", true),
                                        _cache[113] || (_cache[113] = _createTextVNode(" Regénérer le document "))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_divider),
                            _createVNode(_component_v_list_item, {
                              disabled: 
                                        !(
                                            !_ctx.isNewInvoice &&
                                            _ctx.invoice &&
                                            _ctx.invoice.status === 'DRAFT' &&
                                            _ctx.invoice.type !== 'INVOICE_RECURRENT' &&
                                            !_ctx.isDepositOfInvoice
                                        )
                                    ,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogDeleteDocument = true))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[115] || (_cache[115] = [
                                    _createTextVNode("$delete")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[114] || (_cache[114] = [
                                    _createTextVNode("Supprimer")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.mailerDialog)
                  ? (_openBlock(), _createBlock(_component_MailerDialog, {
                      key: 0,
                      modelValue: _ctx.mailerDialog,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.mailerDialog) = $event)),
                      mailType: _ctx.invoiceDefaultMailerInfos.mailType,
                      defaultSubject: _ctx.invoiceDefaultMailerInfos.defaultSubject,
                      defaultText: _ctx.invoiceDefaultMailerInfos.defaultText,
                      companyId: _ctx.companyId,
                      thirdPartyCompanyId: _ctx.invoice.client.id,
                      defaultReceivers: _ctx.invoice.data.receivers,
                      withAttachment: _ctx.invoiceDefaultMailerInfos.withAttachment,
                      invoice: [_ctx.invoice],
                      budgetInsightOptions: _ctx.budgetInsightOptions ? _ctx.budgetInsightOptions : null,
                      invoiceData: _ctx.invoiceData
                    }, null, 8, ["modelValue", "mailType", "defaultSubject", "defaultText", "companyId", "thirdPartyCompanyId", "defaultReceivers", "withAttachment", "invoice", "budgetInsightOptions", "invoiceData"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.preview,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.preview) = $event)),
                    class: "elevation-0",
                    horizontal: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_v_window_item, {
                        value: 0,
                        key: 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, [
                                            (_ctx.isInvoiceMatrix)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode("Factures multiples")
                                                ], 64))
                                              : (_ctx.isRecurrent)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode("Facture récurrente")
                                                  ], 64))
                                                : (
                                                                _ctx.isInvoice &&
                                                                (_ctx.isLocked || _ctx.isDepositOfInvoice)
                                                            )
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      _createTextVNode("Facture")
                                                    ], 64))
                                                  : (_ctx.isCreditNote && _ctx.isLocked)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                        _createTextVNode("Avoir de facture")
                                                      ], 64))
                                                    : (_ctx.isInvoice || _ctx.isCreditNote)
                                                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                          key: 4,
                                                          modelValue: _ctx.invoice.type,
                                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.invoice.type) = $event)),
                                                          items: [
                                                                    {
                                                                        title: 'Facture',
                                                                        value: 'INVOICE',
                                                                    },
                                                                    {
                                                                        title: 'Avoir de Facture',
                                                                        value: 'CREDIT_NOTE',
                                                                    },
                                                                ],
                                                          "item-value": "value",
                                                          "hide-details": "",
                                                          class: "font-weight-normal mr-2",
                                                          disabled: 
                                                                    _ctx.isDepositOfInvoice || _ctx.isLocked
                                                                ,
                                                          "data-cy": "InvoiceEdition-invoice.type",
                                                          density: "compact",
                                                          "item-title": "title"
                                                        }, null, 8, ["modelValue", "disabled"]))
                                                      : (_ctx.isQuote)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                            _createTextVNode("Devis")
                                                          ], 64))
                                                        : (_ctx.isBillOfDelivery)
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                              _createTextVNode("Bon de livraison")
                                                            ], 64))
                                                          : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "8" }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field_filled, {
                                            label: "Titre",
                                            "hide-details": "",
                                            modelValue: _ctx.invoice.title,
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.invoice.title) = $event)),
                                            readonly: _ctx.isLocked,
                                            density: "compact"
                                          }, null, 8, ["modelValue", "readonly"]), [
                                            [_directive_sanitize]
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      (
                                                        !_ctx.isRecurrent && !_ctx.isInvoice && !_ctx.isCreditNote
                                                    )
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12",
                                            class: "py-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_divider)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (
                                                        !_ctx.isRecurrent && !_ctx.isInvoice && !_ctx.isCreditNote
                                                    )
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: "12",
                                            class: "pt-4 d-flex align-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_8, [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  readonly: _ctx.isLocked,
                                                  modelValue: _ctx.invoice.date,
                                                  "onUpdate:modelValue": [
                                                    _cache[19] || (_cache[19] = ($event: any) => ((_ctx.invoice.date) = $event)),
                                                    _cache[20] || (_cache[20] = ($event: any) => (
                                                                _ctx.onDateChanged($event)
                                                            ))
                                                  ],
                                                  label: "Date d'émission",
                                                  "hide-details": "",
                                                  textFieldReadOnly: false,
                                                  filterWithoutClosedAccountingPeriods: 
                                                                !_ctx.isLocked
                                                            ,
                                                  "min-date": 
                                                                _ctx.isLocked
                                                                    ? undefined
                                                                    : _ctx.lastDateInvoice
                                                            
                                                }, null, 8, ["readonly", "modelValue", "filterWithoutClosedAccountingPeriods", "min-date"])
                                              ]),
                                              (
                                                            _ctx.isInvoice || _ctx.isInvoiceMatrix || _ctx.isQuote
                                                        )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createVNode(_component_oss_date_picker_filled, {
                                                      readonly: _ctx.isLocked,
                                                      modelValue: _ctx.invoice.dueDate,
                                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.invoice.dueDate) = $event)),
                                                      filterWithoutClosedAccountingPeriods: 
                                                                !_ctx.isLocked
                                                            ,
                                                      label: "Date d'échéance",
                                                      "hide-details": "",
                                                      textFieldReadOnly: false,
                                                      "min-date": _ctx.invoice.date
                                                    }, null, 8, ["readonly", "modelValue", "filterWithoutClosedAccountingPeriods", "min-date"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.isInvoiceMatrix || _ctx.isInvoice)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                    _createVNode(_component_v_col, { class: "d-flex" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_switch, {
                                                          modelValue: _ctx.invoice.autoValidation,
                                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.invoice.autoValidation) = $event)),
                                                          label: "Validation auto",
                                                          "hide-details": "",
                                                          class: "mt-0",
                                                          readonly: _ctx.isLocked
                                                        }, null, 8, ["modelValue", "readonly"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.isInvoiceMatrix || _ctx.isInvoice)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_switch, {
                                                          modelValue: 
                                                                    _ctx.invoice.sendEmailAfterValidation
                                                                ,
                                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                                                                    _ctx.invoice.sendEmailAfterValidation
                                                                ) = $event)),
                                                          label: "Envoyer un mail",
                                                          "hide-details": "",
                                                          class: "mt-0",
                                                          readonly: _ctx.isLocked
                                                        }, null, 8, ["modelValue", "readonly"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                (!_ctx.isInvoiceMatrix)
                                  ? (_openBlock(), _createBlock(_component_v_form, {
                                      key: 0,
                                      modelValue: _ctx.areRulesValid,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.areRulesValid) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_divider, { class: "mb-2" }),
                                        (!_ctx.invoice.lines.length)
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              "no-gutters": ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex justify-center"
                                                }, {
                                                  default: _withCtx(() => _cache[116] || (_cache[116] = [
                                                    _createTextVNode(" Aucune ligne comptable ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_draggable, {
                                          modelValue: _ctx.invoice.lines,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.invoice.lines) = $event)),
                                          handle: ".handle",
                                          animation: "300",
                                          itemKey: "id"
                                        }, {
                                          item: _withCtx(({ element: line, index }) => [
                                            (_openBlock(), _createBlock(_component_v_row, {
                                              "no-gutters": "",
                                              key: index,
                                              class: "mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "1",
                                                  class: "handle d-flex justify-center align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (
                                                                        !_ctx.isLocked &&
                                                                        !_ctx.isDepositOfInvoice
                                                                    )
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          color: "#AAA",
                                                          size: "x-small",
                                                          style: {"cursor":"move"}
                                                        }, {
                                                          default: _withCtx(() => _cache[117] || (_cache[117] = [
                                                            _createTextVNode("$fa-grip-vertical")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }),
                                                (line.type !== 'TOTAL')
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      cols: "11"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "2" }, {
                                                              default: _withCtx(() => [
                                                                (
                                                                                !_ctx.incomeIsDiscount(
                                                                                    line,
                                                                                )
                                                                            )
                                                                  ? _withDirectives((_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                      key: 0,
                                                                      modelValue: line.quantity,
                                                                      "onUpdate:modelValue": [($event: any) => ((line.quantity) = $event), ($event: any) => (
                                                                                _ctx.updateLineAmounts(
                                                                                    line,
                                                                                )
                                                                            )],
                                                                      label: "Quantité",
                                                                      readonly: 
                                                                                _ctx.isLocked ||
                                                                                _ctx.isDepositOfInvoice
                                                                            ,
                                                                      outlined: "",
                                                                      "hide-details": "",
                                                                      dense: ""
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (
                                                                            !_ctx.incomeIsDiscount(
                                                                                line,
                                                                            ) && !_ctx.areAllDepositLines
                                                                        )
                                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                                  key: 0,
                                                                  cols: "2",
                                                                  class: "pl-2"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _withDirectives(_createVNode(_component_oss_text_field_filled, {
                                                                      modelValue: line.unitPrice,
                                                                      "onUpdate:modelValue": [($event: any) => ((line.unitPrice) = $event), ($event: any) => (
                                                                                _ctx.updateLineAmounts(
                                                                                    line,
                                                                                )
                                                                            )],
                                                                      label: _ctx.unitPriceLabel,
                                                                      readonly: 
                                                                                _ctx.isLocked ||
                                                                                _ctx.isDepositOfInvoice
                                                                            ,
                                                                      outlined: "",
                                                                      "hide-details": "",
                                                                      dense: "",
                                                                      suffix: "€"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : _createCommentVNode("", true),
                                                            (!_ctx.areAllDepositLines)
                                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                                  key: 1,
                                                                  cols: "2",
                                                                  class: "pl-2"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    (
                                                                                !_ctx.incomeIsDiscount(
                                                                                    line,
                                                                                )
                                                                            )
                                                                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                          key: 0,
                                                                          items: _ctx.vatList,
                                                                          modelValue: 
                                                                                line.vatRate
                                                                            ,
                                                                          "onUpdate:modelValue": [($event: any) => ((
                                                                                line.vatRate
                                                                            ) = $event), ($event: any) => (
                                                                                _ctx.updateLineAmounts(
                                                                                    line,
                                                                                )
                                                                            )],
                                                                          modelModifiers: { number: true },
                                                                          "item-title": "text",
                                                                          label: "Taux de TVA",
                                                                          "item-value": "value",
                                                                          "hide-details": "",
                                                                          readonly: "",
                                                                          density: "compact"
                                                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : _createCommentVNode("", true),
                                                            _createVNode(_component_v_col, {
                                                              cols: 
                                                                            _ctx.areAllDepositLines
                                                                                ? '10'
                                                                                : '3'
                                                                        ,
                                                              class: "pl-2"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (
                                                                                !_ctx.displayTTCAmounts
                                                                            )
                                                                  ? _withDirectives((_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                                      key: 0,
                                                                      label: "Montant HT",
                                                                      readonly: "",
                                                                      "hide-details": "",
                                                                      "model-value": 
                                                                                _ctx.newCommonFormatCurrency(
                                                                                    line.netAmount,
                                                                                    undefined,
                                                                                )
                                                                            ,
                                                                      density: "compact"
                                                                    }, null, 8, ["model-value"])), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                                  : _withDirectives((_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                                      key: 1,
                                                                      label: "Montant TTC",
                                                                      readonly: "",
                                                                      "hide-details": "",
                                                                      "model-value": 
                                                                                _ctx.newCommonFormatCurrency(
                                                                                    line.grossAmount,
                                                                                    undefined,
                                                                                )
                                                                            ,
                                                                      density: "compact"
                                                                    }, null, 8, ["model-value"])), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["cols"]),
                                                            (!_ctx.isDeposit)
                                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                                  key: 2,
                                                                  cols: "3",
                                                                  class: "pl-2"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_12, [
                                                                      _createVNode(_component_v_select_filled, {
                                                                        modelValue: 
                                                                                    line.discountType
                                                                                ,
                                                                        "onUpdate:modelValue": [($event: any) => ((
                                                                                    line.discountType
                                                                                ) = $event), ($event: any) => (
                                                                                    _ctx.resetOtherDiscountType(
                                                                                        line,
                                                                                    )
                                                                                )],
                                                                        items: [
                                                                                    '%',
                                                                                    '€',
                                                                                ],
                                                                        label: "Remise",
                                                                        "hide-details": "",
                                                                        density: "compact"
                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                                      _createElementVNode("div", _hoisted_13, [
                                                                        (
                                                                                        line.discountType ===
                                                                                        '%'
                                                                                    )
                                                                          ? _withDirectives((_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                              modelValue: 
                                                                                        line.discountPercentage
                                                                                    ,
                                                                              "onUpdate:modelValue": ($event: any) => ((
                                                                                        line.discountPercentage
                                                                                    ) = $event),
                                                                              text: 
                                                                                        _ctx.limit2decimals(
                                                                                            line.discountPercentage,
                                                                                        )
                                                                                    ,
                                                                              label: "Remise",
                                                                              suffix: "%",
                                                                              readonly: 
                                                                                        _ctx.isLocked
                                                                                    ,
                                                                              rules: [
                                                                                        _ctx.rules.isPercentage,
                                                                                    ],
                                                                              key: 
                                                                                        'fieldDiscountPercentage_' +
                                                                                        index +
                                                                                        '_' +
                                                                                        _ctx.expandKey
                                                                                    ,
                                                                              class: "ml-2 flex-grow-1",
                                                                              "hide-details": ""
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "text", "readonly", "rules"])), [
                                                                              [_directive_sanitize]
                                                                            ])
                                                                          : _withDirectives((_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                              modelValue: 
                                                                                        line.discount
                                                                                    ,
                                                                              "onUpdate:modelValue": ($event: any) => ((
                                                                                        line.discount
                                                                                    ) = $event),
                                                                              label: "Remise",
                                                                              class: "ml-2 flex-grow-1",
                                                                              suffix: "€",
                                                                              readonly: 
                                                                                        _ctx.isLocked
                                                                                    ,
                                                                              rules: [
                                                                                        _ctx.rules.isCorrectAmount,
                                                                                    ],
                                                                              key: 
                                                                                        'fieldDiscount_' +
                                                                                        index +
                                                                                        '_' +
                                                                                        _ctx.expandKey
                                                                                    ,
                                                                              "hide-details": ""
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "rules"])), [
                                                                              [_directive_sanitize]
                                                                            ])
                                                                      ])
                                                                    ])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_row, {
                                                          "no-gutters": "",
                                                          class: "pt-1"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "2" }, {
                                                              default: _withCtx(() => [
                                                                _withDirectives(_createVNode(_component_v_text_field_filled, {
                                                                  modelValue: line.reference,
                                                                  "onUpdate:modelValue": ($event: any) => ((line.reference) = $event),
                                                                  readonly: 
                                                                                _ctx.isLocked ||
                                                                                _ctx.isDepositOfInvoice
                                                                            ,
                                                                  "hide-details": "",
                                                                  label: "Référence",
                                                                  density: "compact"
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]), [
                                                                  [_directive_sanitize]
                                                                ])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, {
                                                              cols: '7',
                                                              class: "pl-2"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _withDirectives(_createVNode(_component_v_text_field_filled, {
                                                                  modelValue: line.title,
                                                                  "onUpdate:modelValue": ($event: any) => ((line.title) = $event),
                                                                  readonly: _ctx.isLocked,
                                                                  "hide-details": "",
                                                                  label: "Nom",
                                                                  density: "compact"
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]), [
                                                                  [_directive_sanitize]
                                                                ])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, {
                                                              cols: '3',
                                                              class: "d-flex justify-end"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (_ctx.isQuote)
                                                                  ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                                      key: 0,
                                                                      modelValue: 
                                                                                line.isOptional
                                                                            ,
                                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                                line.isOptional
                                                                            ) = $event),
                                                                      label: "En option",
                                                                      readonly: _ctx.isLocked,
                                                                      color: "primary"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]))
                                                                  : _createCommentVNode("", true),
                                                                _createVNode(_component_v_btn_icon, {
                                                                  icon: 
                                                                                !line.expand
                                                                                    ? '$fa-chevron-down'
                                                                                    : '$fa-chevron-up'
                                                                            ,
                                                                  onClick: ($event: any) => {
                                                                                line.expand =
                                                                                    !line.expand;
                                                                                _ctx.expandKey++;
                                                                            },
                                                                  size: "small"
                                                                }, null, 8, ["icon", "onClick"]),
                                                                (
                                                                                !_ctx.isLocked &&
                                                                                !_ctx.isDepositOfInvoice
                                                                            )
                                                                  ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                                      key: 1,
                                                                      size: "small",
                                                                      onClick: ($event: any) => (
                                                                                _ctx.removeInvoiceLine(
                                                                                    index,
                                                                                )
                                                                            )
                                                                    }, null, 8, ["onClick"]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_row, {
                                                          "no-gutters": "",
                                                          class: "pt-1"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (line.expand)
                                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                                  cols: "12",
                                                                  key: 
                                                                            'expandedLine_' +
                                                                            index +
                                                                            '_' +
                                                                            _ctx.expandKey
                                                                        
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _withDirectives(_createVNode(_component_v_textarea_filled, {
                                                                      label: "Description",
                                                                      modelValue: 
                                                                                line.description
                                                                            ,
                                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                                line.description
                                                                            ) = $event),
                                                                      readonly: 
                                                                                _ctx.isLocked ||
                                                                                _ctx.isDepositOfQuotation
                                                                            ,
                                                                      "hide-details": "",
                                                                      rows: "1",
                                                                      "auto-grow": "",
                                                                      density: "default"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      cols: "11"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "7" }),
                                                            _createVNode(_component_v_col, { cols: "2" }, {
                                                              default: _withCtx(() => _cache[118] || (_cache[118] = [
                                                                _createElementVNode("div", { class: "totals text-right" }, [
                                                                  _createElementVNode("span", null, " Sous-total HT "),
                                                                  _createElementVNode("br"),
                                                                  _createElementVNode("span", null, " Sous-total TTC ")
                                                                ], -1)
                                                              ])),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { cols: "1" }),
                                                            _createVNode(_component_v_col, { cols: "1" }, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_14, [
                                                                  _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                        line.netAmount,
                                                                                        undefined,
                                                                                    )), 1),
                                                                  _cache[119] || (_cache[119] = _createElementVNode("br", null, null, -1)),
                                                                  _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                        line.grossAmount,
                                                                                        undefined,
                                                                                    )), 1)
                                                                ])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, {
                                                              cols: "1",
                                                              class: "d-flex flex-row justify-end"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (!_ctx.isLocked)
                                                                  ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                                      key: 0,
                                                                      class: "pl-1",
                                                                      onClick: ($event: any) => (
                                                                                _ctx.removeInvoiceLine(
                                                                                    index,
                                                                                )
                                                                            )
                                                                    }, null, 8, ["onClick"]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"]),
                                        _createVNode(_component_v_divider),
                                        (!_ctx.isDeposit)
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 1,
                                              "no-gutters": "",
                                              class: "pt-2 pb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "d-flex justify-end"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "5",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_15, [
                                                              _withDirectives(_createVNode(_component_v_select_filled, {
                                                                modelValue: _ctx.globalDiscountType,
                                                                "onUpdate:modelValue": [
                                                                  _cache[25] || (_cache[25] = ($event: any) => ((_ctx.globalDiscountType) = $event)),
                                                                  _cache[26] || (_cache[26] = ($event: any) => (
                                                                            _ctx.resetOtherDiscountType()
                                                                        ))
                                                                ],
                                                                items: ['%', '€'],
                                                                label: "Remise",
                                                                class: "pr-2 d-flex flex-grow-0 flex-shrink-1",
                                                                "hide-details": "",
                                                                readonly: _ctx.isLocked,
                                                                density: "compact"
                                                              }, null, 8, ["modelValue", "readonly"]), [
                                                                [_directive_sanitize]
                                                              ]),
                                                              _createElementVNode("div", _hoisted_16, [
                                                                (
                                                                                _ctx.globalDiscountType ===
                                                                                '%'
                                                                            )
                                                                  ? _withDirectives((_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                      modelValue: 
                                                                                _ctx.invoice.discountPercentage
                                                                            ,
                                                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((
                                                                                _ctx.invoice.discountPercentage
                                                                            ) = $event)),
                                                                      label: "Remise",
                                                                      class: "flex-grow-1",
                                                                      suffix: "%",
                                                                      key: 
                                                                                'glDiscountPerce_' +
                                                                                _ctx.expandKey
                                                                            ,
                                                                      readonly: _ctx.isLocked,
                                                                      "hide-details": "",
                                                                      rules: [
                                                                                _ctx.rules.isPercentage,
                                                                            ]
                                                                    }, null, 8, ["modelValue", "readonly", "rules"])), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                                  : _withDirectives((_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                      modelValue: 
                                                                                _ctx.invoice.discount
                                                                            ,
                                                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((
                                                                                _ctx.invoice.discount
                                                                            ) = $event)),
                                                                      label: "Remise",
                                                                      class: "flex-grow-1",
                                                                      suffix: "€",
                                                                      key: 
                                                                                'glDiscount_' +
                                                                                _ctx.expandKey
                                                                            ,
                                                                      readonly: _ctx.isLocked,
                                                                      rules: [
                                                                                _ctx.rules.isCorrectAmount,
                                                                            ],
                                                                      "hide-details": ""
                                                                    }, null, 8, ["modelValue", "readonly", "rules"])), [
                                                                      [_directive_sanitize]
                                                                    ])
                                                              ])
                                                            ])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          align: "start",
                                          class: "pt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                (!_ctx.isLocked && !_ctx.isDepositOfInvoice)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createElementVNode("div", _hoisted_17, [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "6" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_InvoiceProductsDialog, {
                                                                  companyId: _ctx.companyId,
                                                                  canBeOptionnal: 
                                                                                _ctx.isQuote
                                                                            ,
                                                                  onValid: _cache[29] || (_cache[29] = ($event: any) => (_ctx.addLine($event)))
                                                                }, {
                                                                  activator: _withCtx(({
                                                                                    props,
                                                                                }) => [
                                                                    _createVNode(_component_v_btn, _mergeProps({ elevation: "0" }, props, { size: "small" }), {
                                                                      default: _withCtx(() => [
                                                                        _cache[121] || (_cache[121] = _createTextVNode(" Ajouter un produit ")),
                                                                        _createVNode(_component_v_icon, {
                                                                          right: "",
                                                                          class: "ml-2"
                                                                        }, {
                                                                          default: _withCtx(() => _cache[120] || (_cache[120] = [
                                                                            _createTextVNode("$add")
                                                                          ])),
                                                                          _: 1
                                                                        })
                                                                      ]),
                                                                      _: 2
                                                                    }, 1040)
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["companyId", "canBeOptionnal"])
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { cols: "6" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_btn, {
                                                                  elevation: "0",
                                                                  onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (
                                                                                _ctx.addSubtTotalLine()
                                                                            ), ["stop"])),
                                                                  "data-cy": "InvoiceEdition-addSousTotal",
                                                                  size: "small"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _cache[123] || (_cache[123] = _createTextVNode(" Ajouter un sous-total ")),
                                                                    _createVNode(_component_v_icon, {
                                                                      right: "",
                                                                      class: "ml-2"
                                                                    }, {
                                                                      default: _withCtx(() => _cache[122] || (_cache[122] = [
                                                                        _createTextVNode("$add")
                                                                      ])),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _createElementVNode("div", _hoisted_18, [
                                                        (_ctx.selectVATType)
                                                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { cols: "6" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_select_filled, {
                                                                      modelValue: 
                                                                                _ctx.invoice.vatType
                                                                            ,
                                                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((
                                                                                _ctx.invoice.vatType
                                                                            ) = $event)),
                                                                      items: _ctx.vatTypes,
                                                                      label: "Type de TVA",
                                                                      "item-key": "key",
                                                                      "item-value": "value",
                                                                      "item-title": "text",
                                                                      "hide-details": "",
                                                                      density: "compact"
                                                                    }, null, 8, ["modelValue", "items"])
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "3" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_19, [
                                                  (_ctx.subjectToVAT)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                                                    : _createCommentVNode("", true),
                                                  (
                                                                    _ctx.subjectToVAT &&
                                                                    !_ctx.displayAllVatRateTotals
                                                                )
                                                    ? (_openBlock(), _createElementBlock("br", _hoisted_21))
                                                    : _createCommentVNode("", true),
                                                  (
                                                                    _ctx.subjectToVAT &&
                                                                    !_ctx.displayAllVatRateTotals
                                                                )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                                                    : _createCommentVNode("", true),
                                                  (
                                                                    _ctx.subjectToVAT &&
                                                                    _ctx.displayAllVatRateTotals
                                                                )
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.vatAmountTotals, (vatTotal, vatTotalIndex) => {
                                                        return (_openBlock(), _createElementBlock("br", {
                                                          key: 
                                                                        'vatTotalRateEmpty_' +
                                                                        vatTotalIndex
                                                                    
                                                        }))
                                                      }), 128))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.displayDepositSwitch)
                                                    ? (_openBlock(), _createBlock(_component_v_switch, {
                                                        key: 4,
                                                        modelValue: _ctx.depositSwitch,
                                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.depositSwitch) = $event)),
                                                        label: "Avec acomptes",
                                                        class: "pt-0 pl-2",
                                                        readonly: _ctx.isLocked,
                                                        "data-cy": "InvoiceEdition-acomptes"
                                                      }, null, 8, ["modelValue", "readonly"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 1
                                            }),
                                            (!_ctx.isBillOfDelivery)
                                              ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_23, [
                                                      (_ctx.subjectToVAT)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Total HT "))
                                                        : _createCommentVNode("", true),
                                                      (
                                                                    _ctx.subjectToVAT &&
                                                                    !_ctx.displayAllVatRateTotals
                                                                )
                                                        ? (_openBlock(), _createElementBlock("br", _hoisted_25))
                                                        : _createCommentVNode("", true),
                                                      (
                                                                    _ctx.subjectToVAT &&
                                                                    !_ctx.displayAllVatRateTotals
                                                                )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Total TVA "))
                                                        : _createCommentVNode("", true),
                                                      _cache[124] || (_cache[124] = _createElementVNode("br", null, null, -1)),
                                                      (
                                                                    _ctx.subjectToVAT &&
                                                                    _ctx.displayAllVatRateTotals
                                                                )
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.vatAmountTotals, (vatTotal, vatTotalIndex) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              style: {"font-size":"0.95em","font-weight":"normal"},
                                                              key: 
                                                                        'vatTotalRate_' +
                                                                        vatTotalIndex
                                                                    
                                                            }, _toDisplayString("TVA (" +
                                                                        vatTotal.vatRate +
                                                                        "%)"), 1))
                                                          }), 128))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(
                                                                    _ctx.isAvailablePriceForCreditNote
                                                                        ? ''
                                                                        : 'text-red'
                                                                )
                                                      }, " Total " + _toDisplayString(_ctx.subjectToVAT ? "TTC" : ""), 3),
                                                      _cache[125] || (_cache[125] = _createElementVNode("br", null, null, -1))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (!_ctx.isBillOfDelivery)
                                              ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_27, [
                                                      (_ctx.subjectToVAT)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        _ctx.netAmountTotal,
                                                                        undefined,
                                                                    )), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                                                                    _ctx.subjectToVAT &&
                                                                    !_ctx.displayAllVatRateTotals
                                                                )
                                                        ? (_openBlock(), _createElementBlock("br", _hoisted_29))
                                                        : _createCommentVNode("", true),
                                                      (
                                                                    _ctx.subjectToVAT &&
                                                                    !_ctx.displayAllVatRateTotals
                                                                )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        _ctx.vatAmountTotal,
                                                                        undefined,
                                                                    )), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[126] || (_cache[126] = _createElementVNode("br", null, null, -1)),
                                                      (
                                                                    _ctx.subjectToVAT &&
                                                                    _ctx.displayAllVatRateTotals
                                                                )
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.vatAmountTotals, (vatTotal, vatTotalIndex) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              style: {"font-size":"0.95em","font-weight":"normal"},
                                                              key: 
                                                                        'vatTotalAmount_' +
                                                                        vatTotalIndex
                                                                    
                                                            }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            -vatTotal.vatAmount,
                                                                            undefined,
                                                                        )), 1))
                                                          }), 128))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(
                                                                    _ctx.isAvailablePriceForCreditNote
                                                                        ? ''
                                                                        : 'text-red'
                                                                )
                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        _ctx.grossAmountTotal,
                                                                        undefined,
                                                                    )), 3),
                                                      _cache[127] || (_cache[127] = _createElementVNode("br", null, null, -1))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.depositSwitch)
                                          ? (_openBlock(), _createBlock(_component_v_card, {
                                              key: 2,
                                              class: "ml-1 mb-2 elevation-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider),
                                                _createVNode(_component_CreateDeposit, {
                                                  modelValue: _ctx.depositIsValid,
                                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.depositIsValid) = $event)),
                                                  invoice: _ctx.invoice,
                                                  grossAmountTotal: _ctx.grossAmountTotal,
                                                  fromQuotation: false,
                                                  onNewDepositsUpdated: _cache[34] || (_cache[34] = ($event: any) => (_ctx.newDeposits = $event))
                                                }, null, 8, ["modelValue", "invoice", "grossAmountTotal"]),
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                                  : (_openBlock(), _createBlock(_component_InvoiceMatrix, {
                                      key: 1,
                                      invoice: _ctx.invoice,
                                      invoiceData: _ctx.invoiceMatrixData,
                                      readonly: _ctx.isLocked
                                    }, null, 8, ["invoice", "invoiceData", "readonly"])),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        (!_ctx.isBillOfDelivery)
                                          ? _withDirectives((_openBlock(), _createBlock(_component_v_textarea_filled, {
                                              key: 0,
                                              label: "Mode de paiement",
                                              "data-cy": "invoiceEdition-payment-type",
                                              modelValue: _ctx.invoice.data.paymentMode,
                                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.invoice.data.paymentMode) = $event)),
                                              readonly: _ctx.isLocked,
                                              rows: "3",
                                              "auto-grow": ""
                                            }, null, 8, ["modelValue", "readonly"])), [
                                              [_directive_sanitize]
                                            ])
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        (!_ctx.isBillOfDelivery)
                                          ? _withDirectives((_openBlock(), _createBlock(_component_v_textarea_filled, {
                                              key: 0,
                                              label: "Détails du paiement",
                                              modelValue: _ctx.invoice.data.paymentDetails,
                                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.invoice.data.paymentDetails) = $event)),
                                              readonly: _ctx.isLocked,
                                              rows: "3",
                                              "auto-grow": ""
                                            }, null, 8, ["modelValue", "readonly"])), [
                                              [_directive_sanitize]
                                            ])
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_textarea_filled, {
                                          label: "Commentaire complémentaire",
                                          modelValue: _ctx.invoice.data.additionalComment,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.invoice.data.additionalComment) = $event)),
                                          readonly: _ctx.isLocked,
                                          rows: "3",
                                          "auto-grow": ""
                                        }, null, 8, ["modelValue", "readonly"]), [
                                          [_directive_sanitize]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_textarea_filled, {
                                          label: "Mentions légales*",
                                          modelValue: _ctx.invoice.data.legalText,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.invoice.data.legalText) = $event)),
                                          readonly: _ctx.isLocked,
                                          rows: "3",
                                          "auto-grow": "",
                                          rules: [_ctx.rules.notEmpty]
                                        }, null, 8, ["modelValue", "readonly", "rules"]), [
                                          [_directive_sanitize]
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "text-right pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.isLocked)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              elevation: "0",
                                              onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.setDefaultLegalForm()), ["stop"])),
                                              "data-cy": "InvoiceEdition-mentions",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[128] || (_cache[128] = [
                                                _createTextVNode(" Mentions Légales par défaut ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_textarea_filled, {
                                          label: "Commentaire interne (non visible à l'édition de la facture)",
                                          modelValue: _ctx.invoice.data.internalComment,
                                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.invoice.data.internalComment) = $event)),
                                          readonly: _ctx.isLocked,
                                          rows: "3",
                                          "auto-grow": ""
                                        }, null, 8, ["modelValue", "readonly"]), [
                                          [_directive_sanitize]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                      (_openBlock(), _createBlock(_component_v_window_item, {
                        value: 1,
                        key: 1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12 mx-auto" }, {
                            default: _withCtx(() => [
                              (_ctx.preview === 1)
                                ? (_openBlock(), _createBlock(_component_InvoiceHtmlTemplateView, {
                                    ref: "invoicePreviewRef",
                                    invoiceThemeSettings: _ctx.invoiceThemeSettings,
                                    invoiceData: _ctx.invoice,
                                    quotation: _ctx.quotation,
                                    forPrint: false,
                                    previewScaleSize: _ctx.previewScaleSize,
                                    company: _ctx.userCompany,
                                    onHtmlGenerated: _cache[42] || (_cache[42] = (html) => (_ctx.generatedHtml = html)),
                                    backgroundImage: _ctx.backgroundImage,
                                    additionalDocument: _ctx.additionalDocument,
                                    key: _ctx.preview,
                                    onDomInfo: _cache[43] || (_cache[43] = ($event: any) => (_ctx.invoiceDomInfo = $event))
                                  }, null, 8, ["invoiceThemeSettings", "invoiceData", "quotation", "previewScaleSize", "company", "backgroundImage", "additionalDocument"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 512)
        ]),
        _: 1
      }, 8, ["cols"]),
      (!_ctx.isInvoiceMatrix)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "4",
            class: "d-flex align-items-end flex-column mt-5"
          }, {
            default: _withCtx(() => [
              (_ctx.isRecurrent || _ctx.isInvoice || _ctx.isCreditNote)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_v_card_title, { style: {"padding-top":"5px","padding-bottom":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "8",
                              class: "text-medium-emphasis text-subtitle-1 pb-4"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.isRecurrent)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Facture récurrente")
                                    ], 64))
                                  : (_ctx.invoice.number)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.invoice.number), 1)
                                      ], 64))
                                    : (_ctx.isInvoice)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createTextVNode("Facture")
                                        ], 64))
                                      : (_ctx.isCreditNote)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createTextVNode("Avoir")
                                          ], 64))
                                        : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "4",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.isLocked && _ctx.isRecurrent)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      location: "bottom"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          elevation: "0",
                                          size: "small"
                                        }, props, {
                                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.reccurencyDialog = true))
                                        }), {
                                          default: _withCtx(() => [
                                            _cache[130] || (_cache[130] = _createTextVNode(" Éditer ")),
                                            _createVNode(_component_v_icon, {
                                              size: "small",
                                              right: ""
                                            }, {
                                              default: _withCtx(() => _cache[129] || (_cache[129] = [
                                                _createTextVNode("$edit")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[131] || (_cache[131] = _createElementVNode("span", null, "Éditer la récurrence", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-1" }, {
                      default: _withCtx(() => [
                        (_ctx.isRecurrent)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              "no-gutters": "",
                              class: "pb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Date de début de facturation : " + _toDisplayString(_ctx.invoice.startDate ? _ctx.formatDate(_ctx.invoice.startDate) : ""), 1)
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.isInfinitReccurency)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Date de fin de facturation : " + _toDisplayString(_ctx.invoice.endDate ? _ctx.formatDate(_ctx.invoice.endDate) : ""), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => _cache[132] || (_cache[132] = [
                                        _createElementVNode("div", null, "Sans date de fin", -1)
                                      ])),
                                      _: 1
                                    })),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Périodicité : " + _toDisplayString(_ctx.invoice.periodicity ? _ctx.formatPeriodicity(_ctx.invoice.periodicity) : ""), 1)
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.isInfinitReccurency)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 2,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.sumUpReccurency()), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Delai de paiement : " + _toDisplayString(_ctx.formatDueDate), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_row, {
                              key: 1,
                              "no-gutters": "",
                              class: "pb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "pr-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_oss_date_picker_filled, {
                                      readonly: _ctx.isLocked,
                                      modelValue: _ctx.invoice.date,
                                      "onUpdate:modelValue": [
                                        _cache[46] || (_cache[46] = ($event: any) => ((_ctx.invoice.date) = $event)),
                                        _cache[47] || (_cache[47] = ($event: any) => (_ctx.onDateChanged($event)))
                                      ],
                                      label: "Date d'émission",
                                      "hide-details": "",
                                      textFieldReadOnly: false,
                                      filterWithoutClosedAccountingPeriods: !_ctx.isLocked,
                                      "min-date": _ctx.lastDateInvoice,
                                      "data-cy": "InvoiceEdition-dateEmission"
                                    }, null, 8, ["readonly", "modelValue", "filterWithoutClosedAccountingPeriods", "min-date"])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.isInvoice || _ctx.isInvoiceMatrix || _ctx.isQuote)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "6",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tooltip, null, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_oss_date_picker_filled, _mergeProps({
                                              readonly: _ctx.isLocked,
                                              modelValue: _ctx.invoice.dueDate,
                                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.invoice.dueDate) = $event)),
                                              label: "Date d'échéance",
                                              "hide-details": "",
                                              textFieldReadOnly: false,
                                              filterWithoutClosedAccountingPeriods: !_ctx.isLocked,
                                              "min-date": _ctx.invoice.date
                                            }, props), null, 16, ["readonly", "modelValue", "filterWithoutClosedAccountingPeriods", "min-date"])
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[133] || (_cache[133] = _createElementVNode("span", null, "Lors de la validation, un mail sera automatiquement envoyé au destinataire ci-dessous", -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })),
                        _createVNode(_component_v_divider),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isRecurrent)
                              ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tooltip, null, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_switch, _mergeProps({
                                          modelValue: _ctx.invoice.autoValidation,
                                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.invoice.autoValidation) = $event)),
                                          label: "Validation auto",
                                          "hide-details": "",
                                          class: "mt-0"
                                        }, props, { readonly: _ctx.isLocked }), null, 16, ["modelValue", "readonly"])
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[134] || (_cache[134] = _createElementVNode("span", null, "Les factures générées seront immédiatement validées (donc non modifiables !)", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_tooltip, null, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_switch, _mergeProps({
                                      modelValue: _ctx.invoice.sendEmailAfterValidation,
                                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.invoice.sendEmailAfterValidation) = $event)),
                                      label: "Envoyer un mail",
                                      "hide-details": "",
                                      class: "mt-0"
                                    }, props, {
                                      "onClick:append": _cache[51] || (_cache[51] = ($event: any) => (
                                            _ctx.invoice.sendEmailAfterValidationWithPaymentLink = false
                                        )),
                                      readonly: _ctx.isLocked
                                    }), null, 16, ["modelValue", "readonly"])
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[135] || (_cache[135] = _createElementVNode("span", null, "A la validation un email sera envoyé si le \"destinataire\" est rempli", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "bg-white rounded-xl mr-3 py-3 my-2 ml-0",
                onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.dialogEditCompany = true))
              }, [
                _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "text-medium-emphasis text-subtitle-1 pb-4"
                        }, {
                          default: _withCtx(() => _cache[136] || (_cache[136] = [
                            _createTextVNode(" Détails de votre société ")
                          ])),
                          _: 1
                        }),
                        (_ctx.invoice.client && _ctx.invoice.client.id)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "4",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.isLocked)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      color: "primary",
                                      elevation: "0",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[138] || (_cache[138] = _createTextVNode(" Éditer ")),
                                        _createVNode(_component_v_icon, {
                                          size: "small",
                                          right: ""
                                        }, {
                                          default: _withCtx(() => _cache[137] || (_cache[137] = [
                                            _createTextVNode("$edit")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "4",
                              xs4: "",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  size: "small",
                                  elevation: "0"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[140] || (_cache[140] = _createTextVNode(" Sélectionner ")),
                                    _createVNode(_component_v_icon, {
                                      size: "small",
                                      right: ""
                                    }, {
                                      default: _withCtx(() => _cache[139] || (_cache[139] = [
                                        _createTextVNode("$edit")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          "primary-title": ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userCompany.name), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pb-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: _normalizeClass([_ctx.userCompany.siret ? '' : 'text-red'])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Siret : " + _toDisplayString((_ctx.userCompany && _ctx.getSiretValue(_ctx.userCompany.siret)) || "manquant"), 1)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.userCompany)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                (
                                    !_ctx.userCompany.address ||
                                    !_ctx.userCompany.postalCode ||
                                    !_ctx.userCompany.city
                                )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Adresse : incomplète"))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(" Adresse : " + _toDisplayString(_ctx.userCompany.address) + " " + _toDisplayString(_ctx.userCompany.postalCode) + " " + _toDisplayString(_ctx.userCompany.city) + " " + _toDisplayString(_ctx.userCompany.country), 1)
                                    ], 64))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.userCompany)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass([_ctx.userCompany.legalForm ? '' : 'text-red'])
                                }, _toDisplayString(_ctx.$t("settings.legalForm")) + " : " + _toDisplayString(_ctx.userCompany.legalForm || "manquant"), 3)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.userCompany)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass([_ctx.userCompany.registrationTown ? '' : 'text-red'])
                                }, "Ville enregistement RCS : " + _toDisplayString(_ctx.userCompany.registrationTown || "manquant"), 3)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_v_card_title, {
                  style: {"padding-top":"5px","padding-bottom":"5px"},
                  onClick: _ctx.openThirdCompanyDialog
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "text-medium-emphasis text-subtitle-1 pb-4"
                        }, {
                          default: _withCtx(() => _cache[141] || (_cache[141] = [
                            _createTextVNode(" Détails du client ")
                          ])),
                          _: 1
                        }),
                        (_ctx.invoice.client && _ctx.invoice.client.id)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "4",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.isLocked)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      color: "primary",
                                      elevation: "0",
                                      size: "small",
                                      disabled: _ctx.isDepositOfInvoice
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[143] || (_cache[143] = _createTextVNode(" Éditer ")),
                                        _createVNode(_component_v_icon, {
                                          size: "small",
                                          right: ""
                                        }, {
                                          default: _withCtx(() => _cache[142] || (_cache[142] = [
                                            _createTextVNode("$edit")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "4",
                              xs4: "",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  size: "small",
                                  elevation: "0"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[145] || (_cache[145] = _createTextVNode(" Sélectionner ")),
                                    _createVNode(_component_v_icon, {
                                      size: "small",
                                      right: ""
                                    }, {
                                      default: _withCtx(() => _cache[144] || (_cache[144] = [
                                        _createTextVNode("$edit")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          "primary-title": ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.invoice.client ? _ctx.invoice.client.name : ""), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_card_text, { class: "pb-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      onClick: _ctx.openThirdCompanyDialog
                    }, {
                      default: _withCtx(() => [
                        (_ctx.dialogSelectCompany)
                          ? (_openBlock(), _createBlock(_component_oss_dialog, {
                              key: 0,
                              modelValue: _ctx.dialogSelectCompany,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.dialogSelectCompany) = $event)),
                              title: 'Choisir un client',
                              onValid: _ctx.validCompany,
                              "hide-valid": _ctx.selectCompanyWindow !== 1,
                              onPrevious: _cache[56] || (_cache[56] = ($event: any) => (_ctx.selectCompanyWindow = 0)),
                              previousDisplay: _ctx.selectCompanyWindow !== 1
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window, {
                                  modelValue: _ctx.selectCompanyWindow,
                                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.selectCompanyWindow) = $event)),
                                  style: {"min-width":"60vw"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_component_v_window_item, {
                                      value: 0,
                                      key: 0
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_company_table, {
                                          showGenericCompany: false,
                                          showConsumerCompany: true,
                                          showCustomerCompanies: true,
                                          showExistingCompanies: false,
                                          company: _ctx.invoice.client ? _ctx.invoice.client.name : '',
                                          siret: _ctx.invoice.client ? _ctx.invoice.client.siret : '',
                                          siren: _ctx.invoice.client ? _ctx.invoice.client.siren : '',
                                          vatNumber: _ctx.invoice.client ? _ctx.invoice.client.vatNumber : '',
                                          parentCompanyId: _ctx.selectedCompany.id,
                                          onSelectCompany: _ctx.companyToEdit
                                        }, null, 8, ["company", "siret", "siren", "vatNumber", "parentCompanyId", "onSelectCompany"])
                                      ]),
                                      _: 1
                                    })),
                                    (_openBlock(), _createBlock(_component_v_window_item, {
                                      value: 1,
                                      key: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_editCompany, {
                                          ref: "editCompany",
                                          "in-company": _ctx.invoice.client,
                                          clientInvoiceMode: true,
                                          onUpdated: _cache[53] || (_cache[53] = ($event: any) => (_ctx.companySelected($event)))
                                        }, null, 8, ["in-company"])
                                      ]),
                                      _: 1
                                    }))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onValid", "hide-valid", "previousDisplay"]))
                          : _createCommentVNode("", true),
                        (_ctx.invoice.client.type !== 'CONSUMER')
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.invoice.client.siret)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" Siret : " + _toDisplayString(_ctx.invoice.client && _ctx.getSiretValue(_ctx.invoice.client.siret)), 1)
                                    ], 64))
                                  : (_ctx.invoice.client.vatNumber)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(" Numero de TVA : " + _toDisplayString(_ctx.invoice.client.vatNumber), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(" Siret : Pas d'information ")
                                      ], 64))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.invoice.client && _ctx.invoice.client.type !== 'CONSUMER')
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Adresse : " + _toDisplayString(_ctx.invoice.client.address) + " " + _toDisplayString(_ctx.invoice.client.postalCode) + " " + _toDisplayString(_ctx.invoice.client.city) + " " + _toDisplayString(_ctx.invoice.client.country), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.invoice.client && _ctx.invoice.client.isActive === false)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "12",
                              class: "text-red"
                            }, {
                              default: _withCtx(() => _cache[146] || (_cache[146] = [
                                _createTextVNode(" Attention : Etablissement fermé ! ")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.thirdPartyCompanyTags.length)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 4,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdPartyCompanyTags, (tpcTag, index) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    label: "",
                                    ripple: false,
                                    key: index,
                                    class: "text mr-1",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                                      }, _toDisplayString(tpcTag.tag.name), 5)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider, { class: "ma-4" }),
                _createVNode(_component_v_card_title, { class: "pt-0 pb-1 text-medium-emphasis text-subtitle-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "text-medium-emphasis text-subtitle-1 pb-4"
                        }, {
                          default: _withCtx(() => _cache[147] || (_cache[147] = [
                            _createTextVNode(" Destinataire ")
                          ])),
                          _: 1
                        }),
                        (_ctx.invoice.client && _ctx.invoice.client.id)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "4",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_btn, {
                                    elevation: "0",
                                    size: "small",
                                    color: "primary",
                                    onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.invoiceThirdCompanyUsersDialog = true)),
                                    "data-cy": "InvoiceEdition-editer"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[149] || (_cache[149] = _createTextVNode(" Éditer ")),
                                      _createVNode(_component_v_icon, { right: "" }, {
                                        default: _withCtx(() => _cache[148] || (_cache[148] = [
                                          _createTextVNode("$edit")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.invoiceThirdCompanyUsersDialog)
                                    ? (_openBlock(), _createBlock(_component_InvoiceThirdCompanyUsersDialog, {
                                        key: 0,
                                        modelValue: _ctx.invoiceThirdCompanyUsersDialog,
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.invoiceThirdCompanyUsersDialog) = $event)),
                                        companyId: _ctx.companyId,
                                        thirdPartyCompanyId: _ctx.invoice.client.id,
                                        onlyToCreate: false,
                                        onValid: _cache[59] || (_cache[59] = ($event: any) => (_ctx.setReceiverUser($event)))
                                      }, null, 8, ["modelValue", "companyId", "thirdPartyCompanyId"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "py-1" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.data.receivers, (receiver, index) => {
                      return (_openBlock(), _createBlock(_component_v_row, {
                        "no-gutters": "",
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "pr-1 pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: receiver.firstname,
                                "onUpdate:modelValue": ($event: any) => ((receiver.firstname) = $event),
                                label: "Prénom",
                                "hide-details": "",
                                readonly: "",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "pl-1 pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: receiver.lastname,
                                "onUpdate:modelValue": ($event: any) => ((receiver.lastname) = $event),
                                label: "Nom",
                                "hide-details": "",
                                readonly: "",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_form, {
                                modelValue: _ctx.isEmailValid,
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.isEmailValid) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: receiver.email,
                                    "onUpdate:modelValue": ($event: any) => ((receiver.email) = $event),
                                    label: "Adresse mail",
                                    rules: [_ctx.rules.isEmail],
                                    readonly: "",
                                    density: "compact"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                ]),
                                _: 2
                              }, 1032, ["modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              (_ctx.invoice.deposits && _ctx.invoice.deposits.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text--secondary subtitle-1 pb-2"
                            }, {
                              default: _withCtx(() => _cache[150] || (_cache[150] = [
                                _createTextVNode(" Acomptes ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-1" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.deposits, (deposit, index) => {
                          return (_openBlock(), _createBlock(_component_v_row, {
                            "no-gutters": "",
                            key: index,
                            class: "d-flex align-center mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "text--primary",
                                style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.formatDate(deposit.date)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "text--primary",
                                style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(deposit.title), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "2",
                                class: "text--primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(deposit.grossAmount, undefined)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "1",
                                class: "text--primary"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, {
                                    icon: "$oss-eye",
                                    class: "btn",
                                    color: 'primary',
                                    onClick: _withModifiers(($event: any) => (
                                    _ctx.$router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId: _ctx.companyId, id: deposit.id },
                                    })
                                ), ["stop"]),
                                    size: "small"
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.invoice.depositOf)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "text--secondary subtitle-1 pb-2"
                              }, {
                                default: _withCtx(() => _cache[151] || (_cache[151] = [
                                  _createTextVNode(" Devis de référence ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pb-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[61] || (_cache[61] = _withModifiers(($event: any) => (
                                _ctx.$router.push({
                                    name: 'invoiceEdition',
                                    params: { companyId: _ctx.companyId, id: _ctx.invoice.depositOf.id },
                                })
                            ), ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "3",
                                        class: "text--primary",
                                        style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.invoice.depositOf.date)), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "text--primary",
                                        style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.invoice.depositOf.title), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "text--primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                            _ctx.invoice.depositOf.grossAmount,
                                            undefined,
                                        )), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "text--primary d-flex justify-end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { icon: "$oss-chevron-right" })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.depositOf.deposits, (depositOfDeposit, index) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: index,
                                  onClick: _withModifiers(($event: any) => (
                                _ctx.$router.push({
                                    name: 'invoiceEdition',
                                    params: { companyId: _ctx.companyId, id: depositOfDeposit.id },
                                })
                            ), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "text--primary",
                                          style: {"font-size":"80%","font-style":"italic"}
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "text--primary",
                                          style: {"font-size":"80%","font-style":"italic"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(depositOfDeposit.title), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "text--primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getPercentageOfDeposit(depositOfDeposit)
                                            ? _ctx.getPercentageOfDeposit(depositOfDeposit) + "%"
                                            : ""), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "text--primary d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { icon: "$oss-chevron-right" })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.invoice.creditNoteOf)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "text-medium-emphasis text-subtitle-1 pb-2"
                                }, {
                                  default: _withCtx(() => _cache[152] || (_cache[152] = [
                                    _createTextVNode(" Avoir de la facture ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, { class: "pb-1" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "3",
                                  class: "text--primary",
                                  style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.invoice.creditNoteOf.date)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "text--primary",
                                  style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.invoice.creditNoteOf.title), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "2",
                                  class: "text--primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.invoice.creditNoteOf.grossAmount, undefined)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "text--primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: "$oss-eye",
                                      class: "btn ml-1",
                                      color: 'primary',
                                      onClick: _cache[62] || (_cache[62] = _withModifiers(($event: any) => (
                                    _ctx.$router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId: _ctx.companyId, id: _ctx.invoice.creditNoteOf.id },
                                    })
                                ), ["stop"])),
                                      size: "small"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.invoice.creditNotes && _ctx.invoice.creditNotes.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "text--secondary subtitle-1 pb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.invoice.creditNotes.length > 1 ? "Avoirs" : "Avoir"), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "pb-1" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.creditNotes, (creditNote, index) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                  "no-gutters": "",
                                  key: index,
                                  class: "d-flex align-center mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "text--primary",
                                      style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(creditNote.date)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "text--primary",
                                      style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(creditNote.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "text--primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(creditNote.grossAmount, undefined)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "text--primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$oss-eye",
                                          class: "btn ml-1",
                                          color: 'primary',
                                          onClick: _withModifiers(($event: any) => (
                                    _ctx.$router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId: _ctx.companyId, id: creditNote.id },
                                    })
                                ), ["stop"]),
                                          size: "small"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
              (_ctx.invoice.replacementOf)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text--secondary subtitle-1 pb-2"
                            }, {
                              default: _withCtx(() => _cache[153] || (_cache[153] = [
                                _createTextVNode(" Remplace la facture ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "3",
                              class: "text--primary",
                              style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.invoice.replacementOf.date)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "text--primary",
                              style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.invoice.replacementOf.title), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "text--primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                    _ctx.invoice.replacementOf.grossAmount,
                                    undefined,
                                )), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "text--primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$oss-eye",
                                  class: "btn ml-1",
                                  color: 'primary',
                                  onClick: _cache[63] || (_cache[63] = _withModifiers(($event: any) => (
                                    _ctx.$router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId: _ctx.companyId, id: _ctx.invoice.replacementOf.id },
                                    })
                                ), ["stop"])),
                                  size: "small"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.invoice.replacedBy)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_v_card_title, { style: {"padding-bottom":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text--secondary subtitle-1 pb-2"
                            }, {
                              default: _withCtx(() => _cache[154] || (_cache[154] = [
                                _createTextVNode(" Est remplacée par la facture ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "3",
                              class: "text--primary",
                              style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.invoice.replacedBy.date)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "text--primary",
                              style: {"overflow":"hidden","display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"1"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.invoice.replacedBy.title), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "text--primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.invoice.replacedBy.grossAmount, undefined)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "text--primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$oss-eye",
                                  class: "btn ml-1",
                                  color: 'primary',
                                  onClick: _cache[64] || (_cache[64] = _withModifiers(($event: any) => (
                                    _ctx.$router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId: _ctx.companyId, id: _ctx.invoice.replacedBy.id },
                                    })
                                ), ["stop"])),
                                  size: "small"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_v_btn_prev, {
                    disabled: _ctx.prevDisabled,
                    onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.prev()))
                  }, null, 8, ["disabled"]),
                  _createVNode(_component_v_btn_next, {
                    disabled: _ctx.nextDisabled,
                    onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.next()))
                  }, null, 8, ["disabled"])
                ]),
                (!_ctx.isLocked)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "elevation-0",
                      onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.saveInvoice())),
                      loading: _ctx.isSaving,
                      disabled: _ctx.disabledSave,
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[155] || (_cache[155] = [
                        _createTextVNode(" Enregistrer ")
                      ])),
                      _: 1
                    }, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogEditCompany,
        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.dialogEditCompany) = $event)),
        actions: _ctx.editCompanyActions,
        title: "Modifier les informations de votre société"
      }, {
        actions: _withCtx(() => _cache[156] || (_cache[156] = [])),
        default: _withCtx(() => [
          _createVNode(_component_editCompany, {
            ref: "editCompany",
            companyId: _ctx.userCompany.id,
            hideUpsertBtn: true,
            actions: _ctx.editCompanyActions,
            onUpdated: _ctx.closeDialogEditCompany
          }, null, 8, ["companyId", "actions", "onUpdated"])
        ]),
        _: 1
      }, 8, ["modelValue", "actions"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.errorDateDialog,
        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.errorDateDialog) = $event)),
        title: "Problème de date"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "body-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" La date de facturation ne peut pas être antérieur a la date de facturation de la dernière facture validée (La dernière facturation date du " + _toDisplayString(_ctx.lastDateInvoice ? _ctx.formatDate(_ctx.lastDateInvoice) : "") + "). ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogCreditNote,
        "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.dialogCreditNote) = $event)),
        title: "Créer un avoir",
        width: "550px"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn_primary, {
            block: "",
            onClick: _cache[70] || (_cache[70] = ($event: any) => {
                        _ctx.dialogCreditNote = false;
                        _ctx.createCreditNote();
                    }),
            "data-cy": "InvoiceEdition-yes",
            size: "large"
          }, {
            default: _withCtx(() => _cache[157] || (_cache[157] = [
              _createTextVNode(" Oui ")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _cache[158] || (_cache[158] = _createTextVNode(" Voulez vous créer un avoir pour cette facture ? "))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogConfirmDuplicate,
        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.dialogConfirmDuplicate) = $event)),
        title: "Dupliquer le document",
        validTitle: 'Dupliquer',
        onValid: _cache[73] || (_cache[73] = ($event: any) => (_ctx.saveInvoice(true))),
        prefixDataCy: "InvoiceEdition-dupliquer"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle({ width: _ctx.$vuetify.display.smAndDown ? '80vw' : '30vw' })
          }, " Voulez-vous vraiment dupliquer ce document ? ", 4)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (!_ctx.isNewInvoice && _ctx.invoice && _ctx.invoice.status === 'DRAFT')
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            modelValue: _ctx.dialogDeleteDocument,
            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.dialogDeleteDocument) = $event)),
            title: "Supprimer la facture",
            onValid: _ctx.deleteDocument,
            validLoading: _ctx.deleteLoading
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({ width: _ctx.$vuetify.display.smAndDown ? '80vw' : '30vw' })
              }, _cache[159] || (_cache[159] = [
                _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir supprimer ce brouillon ? (action irréversible) ", -1)
              ]), 4)
            ]),
            _: 1
          }, 8, ["modelValue", "onValid", "validLoading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.reccurencyDialog,
        "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.reccurencyDialog) = $event)),
        title: "Récurrence",
        width: "40vw",
        validTitle: "Je ne suis pas censé exister",
        validDisabled: "",
        hideValid: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.wizardStep,
            "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.wizardStep) = $event)),
            touchless: "",
            style: {"min-height":"27vh"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  _cache[160] || (_cache[160] = _createTextVNode(" Date de la première facture ")),
                  _createVNode(_component_v_date_picker_wrapper, {
                    modelValue: _ctx.invoice.startDate,
                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.invoice.startDate) = $event)),
                    "full-width": "",
                    landscape: !_ctx.$vuetify.display.mobile,
                    class: "elevation-0",
                    color: "gradient",
                    scrollable: ""
                  }, null, 8, ["modelValue", "landscape"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _cache[161] || (_cache[161] = _createTextVNode(" Date de la dernière facture ")),
                      _createVNode(_component_v_date_picker_wrapper, {
                        modelValue: _ctx.invoice.endDate,
                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.invoice.endDate) = $event)),
                        "full-width": "",
                        landscape: !_ctx.$vuetify.display.mobile,
                        class: "elevation-0",
                        color: "gradient",
                        scrollable: "",
                        disabled: _ctx.isInfinitReccurency
                      }, null, 8, ["modelValue", "landscape", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: _ctx.isInfinitReccurency,
                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.isInfinitReccurency) = $event)),
                        class: "ma-2",
                        label: "Sans date de fin"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reccurencyType, (recType) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: recType.value,
                              onClick: 
                                    () => {
                                        _ctx.invoice.periodicity = recType.value;
                                    }
                                ,
                              style: {"background":"#fff"},
                              class: "mt-2 oss-list-item"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  color: "primary",
                                  icon: 
                                            _ctx.invoice.periodicity === recType.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        
                                }, null, 8, ["icon"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(recType.text), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            outlined: "",
                            modelValue: _ctx.dueDateAmount,
                            "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.dueDateAmount) = $event)),
                            label: "Nombre",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitsOfTime, (unit) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: unit.value,
                              onClick: ($event: any) => (_ctx.unitOfTime = unit.value),
                              style: {"background":"#fff"},
                              class: "mt-2 oss-list-item"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  color: "primary",
                                  icon: 
                                            _ctx.unitOfTime === unit.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        
                                }, null, 8, ["icon"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(unit.text), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            "pt-2": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    disabled: _ctx.wizardStep === 0,
                    rounded: "",
                    elevation: "0",
                    onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.wizardStep--)),
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[162] || (_cache[162] = [
                      _createTextVNode(" Précédent ")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }),
              (_ctx.wizardStep !== 3)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "6",
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        elevation: "0",
                        onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.wizardStep++)),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[163] || (_cache[163] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "6",
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        elevation: "0",
                        onClick: _cache[82] || (_cache[82] = ($event: any) => {
                            _ctx.reccurencyDialog = false;
                            _ctx.wizardStep = 0;
                        }),
                        "data-cy": "InvoiceEdition-valider",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[164] || (_cache[164] = [
                          _createTextVNode(" Valider ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.cancelAndReplaceDialog,
        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.cancelAndReplaceDialog) = $event)),
        title: "Annuler et remplacer",
        validLoading: _ctx.isSaving,
        onValid: _cache[85] || (_cache[85] = ($event: any) => (_ctx.cancelAndReplaceInvoice()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "0",
            class: "px-4 my-4",
            style: {"background-color":"white","border-radius":"25px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-h6 mx-auto" }, {
                default: _withCtx(() => _cache[165] || (_cache[165] = [
                  _createElementVNode("div", null, "Cliquer sur VALIDER va :", -1),
                  _createElementVNode("div", { class: "pl-4" }, " - Créer un avoir opposé à cette facture, et les lettrer ensemble ", -1),
                  _createElementVNode("div", { class: "pl-4" }, " - Créer une nouvelle facture (semblable à celle-ci mais encore modifiable) et vous rediriger dessus ", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "validLoading"]),
      _createVNode(_component_oss_dialog, {
        title: "Convertir",
        modelValue: _ctx.convertDocumentDialog,
        "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.convertDocumentDialog) = $event)),
        hideValid: !_ctx.convertStep,
        validDisabled: !_ctx.depositIsValid,
        validLoading: _ctx.generateDepositloading,
        "previous-display": !!_ctx.convertStep,
        onPrevious: _cache[93] || (_cache[93] = ($event: any) => (_ctx.convertStep--)),
        onValid: _cache[94] || (_cache[94] = ($event: any) => (_ctx.generateDeposits()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.convertStep,
            "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.convertStep) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_v_window_item, {
                value: 0,
                key: 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { "two-lines": "" }, {
                    default: _withCtx(() => [
                      (_ctx.isQuote || _ctx.isBillOfDelivery)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.saveInvoice(true, 'INVOICE'))),
                            class: "mb-2 py-1",
                            "data-cy": "InvoiceEdition-quoteInvoice"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => _cache[167] || (_cache[167] = [
                                  _createTextVNode("$oss-chevron-right")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[166] || (_cache[166] = [
                                  _createTextVNode("Convertir en facture")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isQuote || _ctx.isBillOfDelivery)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.convertStep = 1)),
                            disabled: _ctx.invoice.status === 'DRAFT',
                            class: "mb-2 py-1",
                            "data-cy": "InvoiceEdition-quoteInvoiceWithDeposit"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => _cache[169] || (_cache[169] = [
                                  _createTextVNode("$oss-chevron-right")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[168] || (_cache[168] = [
                                  _createTextVNode("Convertir en facture avec acomptes")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.isQuote)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 2,
                            onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.saveInvoice(true, 'BILL_DELIVERY'))),
                            class: "mt-2 py-1",
                            "data-cy": "InvoiceEdition-quoteDeliveryNote"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => _cache[171] || (_cache[171] = [
                                  _createTextVNode("$oss-chevron-right")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[170] || (_cache[170] = [
                                  _createTextVNode("Convertir en bon de livraison")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_v_window_item, {
                value: 1,
                key: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CreateDeposit, {
                    modelValue: _ctx.depositIsValid,
                    "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.depositIsValid) = $event)),
                    invoice: _ctx.invoice,
                    grossAmountTotal: _ctx.grossAmountTotal,
                    onNewDepositsUpdated: _cache[90] || (_cache[90] = ($event: any) => (_ctx.newDeposits = $event))
                  }, null, 8, ["modelValue", "invoice", "grossAmountTotal"])
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "hideValid", "validDisabled", "validLoading", "previous-display"]),
      _createVNode(_component_oss_dialog, {
        title: "Confirmation",
        modelValue: _ctx.dialogConfirmInvoice,
        "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.dialogConfirmInvoice) = $event)),
        onValid: _cache[96] || (_cache[96] = ($event: any) => (_ctx.confirmInvoiceStepAction())),
        onPrevious: _cache[97] || (_cache[97] = ($event: any) => (_ctx.confirmInvoicePreviousStepAction())),
        "previous-display": _ctx.confirmInvoiceStep != _ctx.confirmInvoiceInitialStep ? true : false,
        prefixDataCy: "InvoiceEdition-valid",
        loading: _ctx.isSaving,
        validDisabled: _ctx.isSaving
      }, {
        default: _withCtx(() => [
          _createVNode(_component_InvoiceConfirmInvoice, {
            step: _ctx.confirmInvoiceStep,
            data: _ctx.confirmInvoiceData,
            type: _ctx.invoiceConfirmInvType,
            otherChrono: _ctx.otherChrono
          }, null, 8, ["step", "data", "type", "otherChrono"])
        ]),
        _: 1
      }, 8, ["modelValue", "previous-display", "loading", "validDisabled"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogPayment,
        "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.dialogPayment) = $event)),
        actions: _ctx.payActions,
        onClose: _cache[99] || (_cache[99] = ($event: any) => (_ctx.dialogPayment = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Pay, {
            withoutCredits: true,
            fromPaymentManagementToGenerateEmail: true,
            companyId: _ctx.companyId,
            thirdPartyCompanyId: _ctx.invoice.client.id,
            accountableAccountName: "411",
            accountingLines: _ctx.accountingLines,
            actions: _ctx.payActions,
            onGetBudgetInsightOptions: _ctx.mailerDialogWithBudgetInsight
          }, null, 8, ["companyId", "thirdPartyCompanyId", "accountingLines", "actions", "onGetBudgetInsightOptions"])
        ]),
        _: 1
      }, 8, ["modelValue", "actions"])
    ]),
    _: 1
  }, 512))
}